import { getImage } from 'gatsby-plugin-image';
import { usePageContext } from '../../../contexts/page';
export const usePageImage = (id) => {
    const { jaenPage } = usePageContext();
    const file = jaenPage?.mediaNodes?.find(node => node.id === id);
    if (file) {
        const image = getImage(file.node.childImageSharp.gatsbyImageData);
        if (image) {
            return {
                image,
                description: file.description
            };
        }
    }
    return undefined;
};
